import { createSlice,createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
const initialState={
    status:'before-upload' 
};
const uploadSlice=createSlice({
    name:"password",
    initialState,
    reducers:{
        setStatus:(state,action:PayloadAction<any>)=>{
            state.status=action.payload;
        }
    }
})
export const { setStatus } = uploadSlice.actions;
export const selectStatus = (state: RootState) => state.uploadReducer.status;

export default uploadSlice.reducer;